module.exports = __webpack_public_path__ + "static/media/06_1440.4065b15f.jpeg";